import { day, sortBy } from '@vrplatform/utils';
import type { HasuraClient } from '@vrplatform/graphql';
import { getCountryByIsoCode, getStateByIsoCode } from '../iso-3166';
import { orderByContact, whereContacts, whereListingPeriod } from '../queries';
import {
  type formatAddress,
  formatUserName,
  getListingName,
  getOwnerCompanyType,
} from '../utils';

export const contactsCsvQuery = async (
  client: HasuraClient,
  input: Parameters<typeof whereContacts>[0],
  _: {
    accountingAppId: string | undefined;
  }
) => {
  const rows = await client.query((q) => {
    return q
      .contacts({
        where: whereContacts(input),
        order_by: orderByContact,
      })
      .map((contact) => {
        const address = (contact.addressData() || null) as
          | Parameters<typeof formatAddress>[0]
          | null;

        // TODO: @LarsBehrenberg GL - add vendor mapping
        // const rightType = `${data.accountingAppId}.vendor`;
        // const leftType = 'finalytic.owner';
        // const settingKey = 'vendor';

        // const vendor =
        //   owner
        //     .settingsRight({
        //       where: {
        //         rightType: { _eq: rightType },
        //         leftType: { _eq: leftType },
        //         key: { _eq: settingKey },
        //         parentSettingId: { _is_null: true },
        //         localAutomationId: { _is_null: true },
        //       },
        //       order_by: [{ updated_at: 'desc' }],
        //       limit: 1,
        //     })
        //     .map((x) => getSourceDescription(x.rightSource))[0] || '';

        const base: Record<string, string | undefined> = {
          Name: contact.name?.trim() || '',
          'First Name': contact.firstName?.trim() || '',
          Type: getOwnerCompanyType(contact.companyType)?.label || 'Individual',
          Email: contact.email,
          Phone: contact.phone,
          'Tax ID': contact.taxId,
          // Address
          'Line 1': address?.line1 || '',
          'Line 2': address?.line2 || '',
          City: address?.city || '',
          'Postal Code': address?.postcode || '',
          'State Code': address?.stateCode || '',
          State:
            getStateByIsoCode(
              address?.stateCode || '',
              address?.countryCode || ''
            )?.name || '',
          'Country Code': address?.countryCode || '',
          Country: getCountryByIsoCode(address?.countryCode || '')?.name || '',
        };

        if (input.type === 'owner') {
          const listings = contact
            .listingPeriodMemberships({
              where: {
                period: whereListingPeriod({
                  date: day().yyyymmdd(),
                  type: 'ownership',
                }),
              },
            })
            .map((member) => getListingName(member.period.listing));

          const userAccess = contact
            .userAccess({
              where: {
                user: {
                  memberships: {
                    tenantId: { _eq: input.tenantId },
                  },
                },
              },
            })
            .map((x) => formatUserName(x.user) || '-');

          base['User Access'] = sortBy(userAccess).join(', ');
          base['Current Ownerships'] = sortBy(listings).join(', ');
        }

        return base;
      });
  });

  return {
    rows: sortBy(rows, 'Name'),
  };
};
